export enum EChangeTarget {
  TRUCK = 'TRUCK',
  TRUCK_BRAND = 'TRUCK_BRAND',
  TRAILER = 'TRAILER',
}
export enum EChangeTargetStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  OVERWRITTEN = 'OVERWRITTEN',
}
